// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__31nbu","info":"PatientInfo_info__1ptB1"};